import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import SoundAssetKeys from '../SoundAssetKeys';

export class JButton extends Phaser.GameObjects.Image {
  constructor(scene, x, y, sprite) {
    super(scene, x, y, ABCyaPhaser.Images.DEFAULT_ATLAS, sprite);

    JButton.instances.push(this);

    this.name = sprite;
    this.enabled = true;
    this.doAction = null;
    this.clickSound = null;

    this.doAction = (sender) => {};

    this.setInteractive().on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.doClick, this);
  }

  doClick () {
    if (!this.enabled) { return; }

    // make button shrink and expand to react to click
    ABCyaPhaser.Tweens.addTween(this, 70, { scale: 0.8 * this.scale, yoyo: true }, Phaser.Math.Easing.Linear);
    this.doAction(this);
  }

  makeDark () {
    this.alpha = 0.5;
  }

  makeBright () {
    this.alpha = 1.0;
  }

  enable () {
    this.enabled = true;
    this.alpha = 1.0;
  }

  disable () {
    this.enabled = false;
    this.alpha = 0.5;
  }

  /** @type {JButton[]} */
  static instances = [];

  static cycleBrightness (type = null) {
    const len = JButton.instances.length;

    for (let i = 0; i < len; i++) {
      const thisOne = JButton.instances[i];
      if (thisOne.type === type || type === null) {
        thisOne.makeDark();
      }
    }

    let prevOne = null;

    for (let i = 0; i < len; i++) {
      const thisOne = JButton.instances[i];
      if (thisOne.type === type || type === null) {
        thisOne.scene.time.delayedCall(i * 200, thisOne.makeBright, null, thisOne);
        if (prevOne) {
          prevOne.scene.time.delayedCall(i * 200, prevOne.makeDark, null, prevOne);
        }
      }
      prevOne = thisOne;
    }

    prevOne.scene.time.delayedCall(len * 200, JButton.makeBrightAll);
  }

  static makeBrightAll (type = null) {
    const len = JButton.instances.length;

    for (let i = 0; i < len; i++) {
      const thisOne = JButton.instances[i];
      if (thisOne.type === type || type === null) {
        thisOne.makeBright();
      }
    }
  }

  static enableAll (type = null) {
    const len = JButton.instances.length;

    for (let i = 0; i < len; i++) {
      const thisOne = JButton.instances[i];
      if (thisOne.type === type || type === null) {
        thisOne.enable();
      }
    }
  }

  static disableAll (type = null) {
    const len = JButton.instances.length;

    for (let i = 0; i < len; i++) {
      const thisOne = JButton.instances[i];
      if (thisOne.type === type || type === null) {
        thisOne.disable();
      }
    }
  }
}